import { title } from 'process';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { link } from 'fs';
import { Options, Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
import { SurveyAnswerService } from '../../public-api';


@Component({
  selector: 'app-quantity',
  templateUrl: './quantity.component.html',
  styleUrls: ['./quantity.component.css']
})
export class QuantityComponent {

  show: boolean = false;

  selectedOptions = [];
  @Input() Question: Question;
  @Input() SurveyBase: Survey;
  timer: any;
  response: string = "";


  questiondsIdLinks: number[] = [];
  questions: Question[] = [];
  result: Question;
  option: Options;

  valueSlider = 0;

  panelOpenState = true;
  popupService: PopupService
  constructor(private dialog: MatDialog, private surveyService: SurveyAnswerService) { }

  numericPattern = /^[0-9]*$/;

  integerOnly(e){
    if (!(((e.keyCode > 95 && e.keyCode < 101) && (e.keyCode > 101 && e.keyCode < 106))
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode == 8 // backspace
          )) {
            return false;
        }
  }

  numericOnly(e){
    if (!(((e.keyCode > 95 && e.keyCode < 101) && (e.keyCode > 101 && e.keyCode < 106))
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode == 8 // backspace
            || e.keyCode == 46 /* dot */
            || e.keyCode == 45
            || e.keyCode == 44)) {
            return false;
        }
  }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog);
    this.option = this.Question.options[0];

    if (this.Question.result || this.option.result) {
      this.treatEditSurvey(this.SurveyBase);
    }
  }

  searchLinkSlider($event) {
    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);

    this.show = true
    this.questions = [];
    this.Question.result = $event;
    this.response = $event;
    this.option.links.map(link => {
      var checkLink = this.verifyLink(link, $event);
      if (checkLink) {
        //this.Question.options[0].result = link.id.toString();
        this.result = this.SurveyBase.questions.find(x => x.id == link.questionDestinationId);
        if (this.result != null) {
          this.questions.push(this.result);
        }
      }
      /** Open popus */
      if (link.popupDestinationId != null) {
        this.popupService.openPopupDialog(link.popupDestinationId, this.SurveyBase);
      }

      /**open tip */
      if (link.tipDestinationTipId != null) {
        this.popupService.openTipDialog(link.tipDestinationTipId);
      }
    }, this)

    this.questions = this.questions.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
  }

  //choix multiple
  onNgModelChange($event) {

    if (this.timer != null) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);


    this.Question.options.forEach(option => {
      option.result = null
    });


    this.response = "";
    this.selectedOptions.forEach(element => {
      this.response = this.response + " / " + element.title
    });


    this.response = this.response.substring(this.response.indexOf("/") + 1)
    this.show = true
    this.questiondsIdLinks = [];
    this.questions = [];
    this.Question.result = "";

    $event.forEach(element => {
      this.Question.result = this.Question.result + " / " + element.id;
      if (this.Question?.options.find(x => x.id == element.id)?.links != null) {
        var option = this.Question?.options.find(x => x.id == element.id);
        option.title = element.title
        option.result = element.title

        this.Question.options.find(x => x.id == element.id).links.forEach(element => {
          element.questionDestinationId;
          this.questiondsIdLinks.push(element.questionDestinationId);
          /** Open popus */
          if (element.popupDestinationId != null) {
            this.popupService.openPopupDialog(element.popupDestinationId, this.SurveyBase);
          }

          /**open tip */
          if (element.tipDestinationTipId != null) {
            this.popupService.openTipDialog(element.tipDestinationTipId);
          }
        });

        this.questiondsIdLinks.forEach(element => {


          this.result = this.SurveyBase.questions.find(x => x.id == element);

          if (this.result != null && this.questions.indexOf(this.result) == -1) {
            this.questions.push(this.result);
          }
        })

      }
    });

    this.questions = this.questions.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })



  }

  //saisie nombre
  lessOrMore($event, option): void {

    if (this.timer != null) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);


    this.questiondsIdLinks = [];
    this.questions = [];
    this.show = true;
    this.Question.result = ""

    this.Question.options.forEach(element => {
      this.Question.result = this.Question.displayMode == 3 ? element.result : this.Question.result + " " + element.title + " : " + element.result + " /"
      this.response = this.Question.result

      if (element.result != null) {
        if (element?.links.length > 0) {
          element?.links.forEach(link => {
            var checkLink = this.verifyLink(link, $event);
            if (checkLink) {
              link.questionDestinationId;
              this.questiondsIdLinks.push(link.questionDestinationId);
              /** Open popus */
              if (link.popupDestinationId != null) {
                this.popupService.openPopupDialog(link.popupDestinationId, this.SurveyBase);
              }

              /**open tip */
              if (link.tipDestinationTipId != null) {
                this.popupService.openTipDialog(link.tipDestinationTipId);
              }
            }
          });
          this.questiondsIdLinks.forEach(element => {
            this.result = this.SurveyBase.questions.find(x => x.id == element);
            if (this.result != null) {
              this.questions.push(this.result);
            }
          })
        }
      }
    });

    this.questions = this.questions.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
  }

  /**
   * Analyse si un lien a besoin d'être parcouru
   * @param link lien à tester
   * @param v valeure répondue
   * @returns true si le lien doit être parcouru, false sinon
   */
  verifyLink(link, v) {
    if (link.conditionType === 1 && link.conditionMinValue <= v && link.conditionMaxValue >= v) { // range value
      return true;
    } else if (link.conditionType === 2 && link.conditionMinValue < v) { // more than
      return true;
    } else if (link.conditionType === 3 && link.conditionMinValue > v) { // less than
      return true;
    } else if (link.conditionType === 0) {
      return true;
    } else if (link.conditionType === null) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Récupère une réponse déjà donnée lors d'une précédente saisie pour la remettre en édition dans le questionnaire en cours de réponse
   * @param survey le questionnaire complet
   */
  treatEditSurvey(survey) {

    this.panelOpenState = false;
    this.show = true;
    let optionIds = [];

    // plus / moins
    if (this.Question.displayMode == 0) {
      let arrayResult = this.Question.result.split('/', this.Question.result.length);
      arrayResult = arrayResult.splice(arrayResult.length - 1);

      arrayResult.forEach(element => {
        let arrayOption = this.Question.result.split('/', this.Question.result.length);
        arrayOption.forEach(element => {

          let optionSplit = element.split(':', this.Question.result.length);
          let titleSubstring = optionSplit[0].replace(/\s/g, "");
          optionIds.push(titleSubstring);
          let option = this.Question.options.find(x => x.title == titleSubstring)
          if (optionSplit[1] != null) {
            option.result = optionSplit[1].replace(/\s/g, "");
            option.links.forEach(element => {
              this.response = this.response + " " + option.title + " : " + option.result + " /"
              element.questionDestinationId;
              this.questiondsIdLinks.push(element.questionDestinationId);
              /** Open popus */
              this.questiondsIdLinks.forEach(element => {
                this.result = this.SurveyBase.questions.find(x => x.id == element);
                if (this.result != null) {

                  this.questions.push(this.result);

                }
              })
            })
          }
        });

      });
    }
    // slider
    else if (this.Question.displayMode == 1) {
      var option = this.Question.options[0];
      this.response = option.result;
      this.searchLinkSlider(this.option.result);
    }
    // Choix unique
    else if (this.Question.displayMode == 2) {
      this.panelOpenState = false;
      this.show = true;
      let arrayOption = this.Question.result.split('/', this.Question.result.length);
      arrayOption.forEach(optionResult => {
        if (optionResult) {
          this.Question.options.forEach(option => {
            if (option.id.toString() === optionResult) {
              option.checked = true

              this.response = this.response + " / " + option.title;

              option.links.forEach(element => {

                element.questionDestinationId;
                this.questiondsIdLinks.push(element.questionDestinationId);
                /** Open popus */
                this.questiondsIdLinks.forEach(element => {
                  this.result = this.SurveyBase.questions.find(x => x.id == element);
                  if (this.result != null) {

                    this.questions.push(this.result);
                  }
                });
              });
            }
          });
        }
      });

      this.response = this.response.substring(this.response.indexOf("/") + 1);
    }
    // Saisie de nombre
    else if (this.Question.displayMode == 3){
      this.response = this.option.result;
      this.handleLinks(this.option)
    }

    this.questions = this.questions.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
  }


  handleLinks(option) {
    this.questiondsIdLinks = [];
    this.questions = [];

    option.links.forEach(element => {
      element.questionDestinationId;
      this.questiondsIdLinks.push(element.questionDestinationId);

      /**Open popup */
      if (element.popupDestinationId != null) {
        this.popupService.openPopupDialog(element.popupDestinationId, this.SurveyBase);
      }

      /**open tip */
      if (element.tipDestinationTipId != null) {
        this.popupService.openTipDialog(element.tipDestinationTipId);
      }
    });

    this.questiondsIdLinks.forEach(element => {
      this.result = this.SurveyBase.questions.find(x => x.id == element);
      if (this.result) {
        this.questions.push(this.result);
      }
    });
  }

  sortBy(prop: string) {
    return this.Question.options.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }
}



